import React from 'react'
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material'

const InstagramIcon = (props: SvgIconProps) => {
  // @ts-ignore
  const { color, fill, stroke, sx, width, height, ...otherProps } = props // eslint-disable-line
  const theme = useTheme()

  let selectedColor = color

  // @ts-ignore
  if (color && theme.palette[color]) {
    // @ts-ignore
    selectedColor = theme.palette[color].main
  }

  const fillStyle = fill || selectedColor || undefined

  const styles = {
    width: 'inherit',
    height: 'inherit',
    fill: 'inherit',
    ...sx,
  }

  const cleanedPaths = () => (
    <svg
      width={width || 48}
      height={height || 48}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M24.0002 17.7516C20.5596 17.7516 17.7518 20.5594 17.7518 24C17.7518 27.4407 20.5596 30.2485 24.0002 30.2485C27.4408 30.2485 30.2487 27.4407 30.2487 24C30.2487 20.5594 27.4408 17.7516 24.0002 17.7516ZM42.7408 24C42.7408 21.4125 42.7643 18.8485 42.619 16.2657C42.4737 13.2657 41.7893 10.6032 39.5955 8.4094C37.3971 6.21096 34.7393 5.53128 31.7393 5.38596C29.1518 5.24065 26.5877 5.26409 24.0049 5.26409C21.4174 5.26409 18.8533 5.24065 16.2705 5.38596C13.2705 5.53128 10.608 6.21565 8.41428 8.4094C6.21585 10.6078 5.53616 13.2657 5.39085 16.2657C5.24553 18.8532 5.26897 21.4172 5.26897 24C5.26897 26.5828 5.24553 29.1516 5.39085 31.7344C5.53616 34.7344 6.22053 37.3969 8.41428 39.5907C10.6127 41.7891 13.2705 42.4688 16.2705 42.6141C18.858 42.7594 21.4221 42.736 24.0049 42.736C26.5924 42.736 29.1565 42.7594 31.7393 42.6141C34.7393 42.4688 37.4018 41.7844 39.5955 39.5907C41.794 37.3922 42.4737 34.7344 42.619 31.7344C42.769 29.1516 42.7408 26.5875 42.7408 24ZM24.0002 33.6141C18.6799 33.6141 14.3862 29.3203 14.3862 24C14.3862 18.6797 18.6799 14.386 24.0002 14.386C29.3205 14.386 33.6143 18.6797 33.6143 24C33.6143 29.3203 29.3205 33.6141 24.0002 33.6141ZM34.008 16.2375C32.7658 16.2375 31.7627 15.2344 31.7627 13.9922C31.7627 12.75 32.7658 11.7469 34.008 11.7469C35.2502 11.7469 36.2533 12.75 36.2533 13.9922C36.2537 14.2872 36.1959 14.5793 36.0832 14.8519C35.9705 15.1245 35.8051 15.3721 35.5965 15.5807C35.388 15.7893 35.1403 15.9547 34.8677 16.0674C34.5951 16.1801 34.303 16.2379 34.008 16.2375Z"
        fill={fillStyle || '#2B2E31'}
      />
    </svg>
  )

  return (
    <SvgIcon
      component={cleanedPaths}
      inheritViewBox
      sx={styles}
      {...otherProps}
    />
  )
}

export default InstagramIcon
